import { SET_AUDIENCE, SET_REPORTS, START_REPORTS } from "./constants";
import { setAudience, setReports, startReports } from "./helper";

const INITIAL_STATE = {
  loading: false,
  reports: {
    labels: [],
    conversations: [],
    sent: [],
    received: [],
  },
  audience: {
    agePercentage: [],
    genderPercentage: [],
    locationPercentage: [],
    topCities: [],
  },
  fetchError: "",
};

const reportsReducer = (state = INITIAL_STATE, actions) => {
  switch (actions.type) {
    case START_REPORTS:
      return startReports(state, actions.payload);

    case SET_REPORTS:
      return setReports(state, actions.payload);

    case SET_AUDIENCE:
      return setAudience(state, actions.payload);

    default:
      return state;
  }
};

export default reportsReducer;
